import styled from '@pinecast/styles';
import * as React from 'react';

export interface ShortcutKey {
  letter: string;
  metaKey?: boolean;
  optionKey?: boolean;
}

const Wrapper = styled('span', {display: 'inline-block', fontSize: '0.6em'});
const Spacer = styled('span', {margin: '0 0.25em'});

const userAgent =
  typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : 'node';

const isMobile = userAgent.includes('mobile') || userAgent.includes('tablet');
const isMacOS = userAgent.includes('macintosh');
// const isWindows = userAgent.includes('windows');

function renderMeta() {
  if (isMacOS) {
    return '⌘';
  }
  return 'ctrl';
}
function renderOption() {
  if (isMacOS) {
    return '⌥';
  }
  return 'alt';
}

type AvailableStyles = Pick<
  React.CSSProperties,
  | 'alignSelf'
  | 'color'
  | 'fontSize'
  | 'fontWeight'
  | 'justifySelf'
  | 'lineHeight'
  | 'letterSpacing'
  | 'margin'
  | 'marginBottom'
  | 'marginLeft'
  | 'marginRight'
  | 'marginTop'
  | 'opacity'
  | 'textDecoration'
  | 'textShadow'
  | 'textTransform'
>;

const KeyboardShortcut = ({
  style,
  ...shortcut
}: ShortcutKey & {style?: AvailableStyles}) => {
  if (isMobile) {
    return <span />;
  }
  const modifiers = [
    shortcut.metaKey ? renderMeta() : null,
    shortcut.optionKey ? renderOption() : null,
  ].filter(x => x);

  return (
    <Wrapper style={style}>
      {modifiers.reduce(
        (acc, cur) => (
          <>
            {cur}
            <Spacer>+</Spacer>
            {acc}
          </>
        ),
        <>{shortcut.letter.toUpperCase()}</>,
      )}
    </Wrapper>
  );
};

export default KeyboardShortcut;
